import React, { Fragment, useEffect, useState, useContext } from "react";
import {
  Alert,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from "reactstrap";

import SikkaCardHeader from "../../common/SikkaCardHeader";
import Loader from "../../common/Loader";
import Flex from "../../common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPerson,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import CustomerDetailRow from "../../common/CustomerDetailRow";
import apiCall, { ip } from "../../../services/apiCall";
import PlaceholderLoading from "react-placeholder-loading";
import AppContext from "../../../context/Context";
import { detect } from "detect-browser";
const browser = detect();
const HubspotTechnicalSupportDetails = ({
  hubspotOwner,
  setShowHubspotOwnerCard,
}) => {
  const [loading, setLoading] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [hideHubspotOwnerDetails, setHideHubspotOwnerDetails] = useState(true);
  const [name, setName] = useState("");
  const { loginUserDetails } = useContext(AppContext);
  useEffect(() => {
    if (hubspotOwner && hubspotOwner != "") {
      setLoading(true);
      let param = {
        owner_id: `${hubspotOwner}`,
        user_dev_id:loginUserDetails.dev_id
      };
      apiCall
        .servertrip("GET", "hubspotcompanyowner", loginUserDetails, param)
        .then((res) => {
          let data = res.data.items;
          setHideHubspotOwnerDetails(false);
          setEmailAddress(data.owner_email);
          setName(`${data.owner_first_name} ${data.owner_last_name}`);
          setLoading(false);
        })
        .catch((error) => {
          setShowHubspotOwnerCard(false);
        });
    }
  }, [hubspotOwner]);
  const trackUser = () => {
    let body = {
      dev_id: loginUserDetails?.dev_id,
      email_id: loginUserDetails?.user_name,
      dev_name: loginUserDetails?.dev_name,
      is_admin: loginUserDetails?.is_partner === "0" ? "yes" : "no",
      ip_address: ip,
      browser_name:
        browser.name.charAt(0).toUpperCase() + browser.name.slice(1),
      browser_version: browser.version,
      host_name: window.location.hostname,
    };
    apiCall
      .servertrip(
        "POST",
        "discord_community_tracking",
        loginUserDetails,
        undefined,
        body
      )
      .then((res) => {})
      .catch((error) => {});
  };
  return (
    <Card className="mb-3 w-100">
      <Fragment>
        <SikkaCardHeader title="Sikka Technical Support Details" />
        <CardBody className="">
          {loading ? (
            <div style={{ width: "100%" }}>
              <Loader />
            </div>
          ) : (
            <>
              {hideHubspotOwnerDetails ? (
                <></>
              ) : (
                <Row className="mb-3 pl-3 pr-3">
                  <h5 className="fs-0 fw-bold mb-3">
                    You can contact your sikka technical support manager or
                    create support ticket if you have any technical question or
                    issue.
                  </h5>
                  <Row className="g-1">
                    <Col lg={6} xxl={4} className="my-1">
                      <Flex
                        alignItems="center"
                        className="p-3 bg-light rounded border position-relative"
                      >
                        <Row className={`mb-1 `}>
                          <Col xs={1} className="mt-1">
                            <FontAwesomeIcon className="fa-lg" icon={faUser} />
                          </Col>
                          <Col className="pl-0 pr-0">
                            <Col className="mr-0" xs={12}>
                              <p className={"font-weight-semi-bold fs--1 mb-1"}>
                                {loading ? (
                                  <PlaceholderLoading
                                    shape="rect"
                                    width={200}
                                    height={15}
                                  />
                                ) : (
                                  "Support manager name"
                                )}
                              </p>
                            </Col>
                            <Col className="fs--1" xs={12}>
                              {loading ? (
                                <PlaceholderLoading
                                  shape="rect"
                                  width={250}
                                  height={15}
                                />
                              ) : (
                                name
                              )}
                            </Col>
                          </Col>
                        </Row>
                      </Flex>
                    </Col>
                    <Col lg={6} xxl={4} className="my-1">
                      <Flex
                        alignItems="center"
                        className="p-3 bg-light rounded border position-relative"
                      >
                        <Row className={`mb-1`}>
                          <Col xs={1} className="mt-1">
                            <FontAwesomeIcon
                              className="fa-lg"
                              icon={faEnvelope}
                            />
                          </Col>
                          <Col className="pl-0 pr-0">
                            <Col className="mr-0" xs={12}>
                              <p className={"font-weight-semi-bold fs--1 mb-1"}>
                                {loading ? (
                                  <PlaceholderLoading
                                    shape="rect"
                                    width={200}
                                    height={15}
                                  />
                                ) : (
                                  "Support manager email"
                                )}
                              </p>
                            </Col>
                            <Col className="fs--1" xs={12}>
                              {loading ? (
                                <PlaceholderLoading
                                  shape="rect"
                                  width={250}
                                  height={15}
                                />
                              ) : (
                                emailAddress
                              )}
                            </Col>
                          </Col>
                        </Row>
                      </Flex>
                    </Col>
                  </Row>
                </Row>
              )}
              <Row className="pl-3 pr-3">
                <h5
                  className="fs-0 fw-semi-bold mb-2 text-primary-emphasis"
                  onClick={() => {
                    trackUser();
                  }}
                >
                  <a
                    href="https://discord.gg/SNrc5zfhe5"
                    target="_blank"
                    className="animate-charcter"
                  >
                    You can explore the Sikka developer community for technical
                    support by clicking here.
                  </a>
                </h5>
              </Row>
            </>
          )}
        </CardBody>
      </Fragment>
    </Card>
  );
};
export default HubspotTechnicalSupportDetails;
